import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_ctx.deleteAuditCheckResultDialog)
    ? (_openBlock(), _createBlock(_component_oss_dialog, {
        key: 0,
        modelValue: _ctx.deleteAuditCheckResultDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deleteAuditCheckResultDialog) = $event)),
        withoutHeader: "true",
        "valid-title": "Valider",
        "valid-loading": _ctx.deleteAuditCheckResultLoading,
        onValid: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteAuditCheckResults())),
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close())),
        "min-width": "45vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_alert, {
            border: "start",
            "border-color": "red",
            class: "py-4 mb-0"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("h3", { class: "text-center" }, "Êtes vous sûr de vouloir supprimer ce contrôle ?", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "valid-loading"]))
    : _createCommentVNode("", true)
}